import { render } from "./Cargomodal.vue?vue&type=template&id=3bf0879d"
import script from "./Cargomodal.vue?vue&type=script&lang=js"
export * from "./Cargomodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__